/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Required_TitleInputs */



/**
* | output |
* | --- |
* | "Upgrade to unlock this feature" |
*
* @param {Upgrade_Required_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const upgrade_required_title = /** @type {((inputs?: Upgrade_Required_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Required_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Passez à une offre supérieure pour débloquer cette fonctionnalité")
	if (locale === "de") return /** @type {LocalizedString} */ ("Upgraden, um diese Funktion freizuschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Passa a un piano superiore per sbloccare questa funzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейдите на другой тариф, чтобы открыть эту функцию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mejora tu plan para desbloquear esta función")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("升级以解锁此功能")
	if (locale === "ja") return /** @type {LocalizedString} */ ("この機能を使うにはアップグレードしてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह सुविधा पाने के लिए अपग्रेड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Faça upgrade para desbloquear esta funcionalidade")
	return /** @type {LocalizedString} */ ("Upgrade to unlock this feature")
});